import { useContext } from 'react';
import backgroundChords from '../images/about-background-chords.svg';
import { LanguageContext, localize } from '../Localization'

import './styles.scss';

export default function About() {
  const language = useContext(LanguageContext)

  const questionArray = [1, 2, 3, 4, 5, 6]

  return (
    <div className='About' style={{ backgroundImage: `url(${backgroundChords})` }}>
      <div className='section'>
        <h2>
          {localize( language, 'about', 'title' )}
        </h2>
        <p>
          {localize( language, 'about', 'description' )}
        </p>
        {questionArray.map((q, i) => (
          <div key={i}>
            <h3>{localize( language, 'about', `q${q}`)}</h3>
            <p>{localize( language, 'about', `a${q}`)}</p>
          </div>
        ))}

        <p className='note'>
          {localize(language, 'about', 'note')}
        </p>
      </div>
    </div>
  );
}
